import React from "react"
export default function NotFound() {
    const NotFoundImg = process.env.PUBLIC_URL + '/images/assets/notfound2.png'

    return (
        <>
            <div className="text-gray-900 min-h-screen flex items-center">
                <div className="container mx-auto p-4 flex flex-wrap items-center">
                    <div className="w-full md:w-5/12 text-center p-4">
                        <img
                            src={NotFoundImg}
                            alt="Not Found"
                        />
                    </div>
                    <div className="w-full md:w-7/12 text-center md:text-left p-4">
                        <div className="text-xl md:text-3xl font-extrabold mb-4">
                            Oh dear. This page is gone.
                        </div>
                        <div className="text-xl mb-0">
                            You may have mistyped the address <br />or the page may have moved.
                        </div>

                        <div className="text-left">
                            <a href="/" className="inline-flex mt-4 items-center justify-center py-2 px-4 rounded-3xl border border-pblue text-white font-medium rounded-md bg-white bg-pblue">
                                <i className="mr-1 mdi mdi-arrow-left"></i> Go back
                            </a>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}


